import React, { useEffect, useState } from 'react'
import { Typography, TextField, Button } from '@material-ui/core'
import { useMutation, useQuery } from '@apollo/client'
import { match } from 'ts-pattern'
import { useSystemPromptsStyles } from './SystemPrompts.styles'
import { GET_SYSTEM_PROMPT, UPDATE_SYSTEM_PROMPT } from '../../../entities/prompts/queries'
import AlertMessage from '../../../components/AlertMessage'

function SystemPrompts() {
  const classes = useSystemPromptsStyles()
  const { data, loading: isGettingSystemPrompt, refetch } = useQuery(GET_SYSTEM_PROMPT)
  const [updateSystemPrompt, { loading: isUpdatingSystemPrompt }] = useMutation(
    UPDATE_SYSTEM_PROMPT,
    {
      onCompleted: () => {
        refetch()
        setAlert({
          isOpen: true,
          message: 'System prompt updated successfully',
          severity: 'success',
        })
      },
      onError: error => {
        setAlert({
          isOpen: true,
          message: `Error updating system prompt: ${error.message}`,
          severity: 'error',
        })
      },
    },
  )

  const [systemPrompt, setSystemPrompt] = useState(data?.getSystemPrompt?.content || '')
  const [alert, setAlert] = useState({ isOpen: false, message: '', severity: '' })

  const hasChanges = systemPrompt !== data?.getSystemPrompt?.content

  const handleSystemPromptChange = e => {
    const newValue = e.target.value
    setSystemPrompt(newValue)
  }

  const handleSaveSystemPrompt = () => {
    updateSystemPrompt({
      variables: {
        data: { content: systemPrompt, expectedVersion: data?.getSystemPrompt?.version },
      },
    })
  }

  const handleCloseAlert = () => {
    setAlert({ ...alert, isOpen: false })
  }

  const handleRestoreOriginal = () => {
    setSystemPrompt(data?.getSystemPrompt?.content || '')
  }

  useEffect(() => {
    if (isGettingSystemPrompt) return
    setSystemPrompt(data?.getSystemPrompt?.content || '')
  }, [isGettingSystemPrompt, data])

  return (
    <div className={classes.root}>
      <Typography variant="h2" component="h6">
        System Prompts
      </Typography>
      <TextField
        multiline
        disabled={isGettingSystemPrompt}
        minRows={15}
        maxRows={24}
        value={systemPrompt}
        onChange={handleSystemPromptChange}
        variant="outlined"
        fullWidth
      />

      <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveSystemPrompt}
          disabled={isUpdatingSystemPrompt || !hasChanges}
          style={{ flex: 1 }}
        >
          {match({ isLoading: isUpdatingSystemPrompt, hasChanges })
            .with({ isLoading: true }, () => 'Saving...')
            .with({ isLoading: false, hasChanges: false }, () => 'No changes')
            .with({ isLoading: false, hasChanges: true }, () => 'Save')
            .exhaustive()}
        </Button>

        <Button
          variant="outlined"
          onClick={handleRestoreOriginal}
          disabled={isGettingSystemPrompt || !hasChanges}
          style={{ flex: 1 }}
        >
          Restore Original
        </Button>
      </div>

      <AlertMessage
        isOpen={alert.isOpen}
        handleClose={handleCloseAlert}
        message={alert.message}
        severity={alert.severity}
      />
    </div>
  )
}

export default SystemPrompts
